import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { DeleteOutline, BorderColorOutlined } from "@mui/icons-material";
import moment from "moment";
import { useState } from "react";
import axios from "../../axios/axios";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import dayjs from "dayjs";

const BonusCard = (props) => {
  const {
    minimum_loan_amount,
    maximum_loan_amount,
    payout_days,
    name,
    endDate,
    startDate,
    bonus,
    bonus_type,
    bonus_distribution_period,
    id,
    qualifying_loan_amounts
  } = props?.cardData;
  const dispatch = useDispatch();
  let formatedStartDate = dayjs(startDate).format("DD MMM YYYY").toUpperCase();
  let formatedEndDate = dayjs(endDate).format("DD MMM YYYY").toUpperCase();
  let bonDisPeriod = "";
  switch (bonus_distribution_period) {
    case "weekly":
      bonDisPeriod = "Calendar Week";
      break;
    case "monthly":
      bonDisPeriod = "Calendar Month";
      break;
    case "quarterly":
      bonDisPeriod = "Calendar Quarter";
      break;
    case "half-yearly":
      bonDisPeriod = "Calendar Half";
      break;
    case "yearly":
      bonDisPeriod = "Calendar Year";
      break;
    default:
      break;
  }

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [delPopOpen, setDelPopOpen] = useState(false);
  const handleClose = (act) => {
    setAnchorEl(null);
    if (act === "edit") {
      props.closeBonusPopUp(props.bonus);
    }
    if (act === "del") {
      setDelPopOpen(true);
    }
  };
  const handleCloseDel = async (act) => {
    setDelPopOpen(false);
  };
  return (
    <div className="w-full max-[450px]:flex-col max-w-full bg-white rounded-[8px] border border-[#E0E0E0] flex overflow-hidden relative">
      <div className="bg-[#0E085C] text-white flex flex-wrap items-center justify-center gap-[15px] relative w-[310px] max-w-full flex-shrink-0 max-[450px]:w-full max-[450px]:py-[20px]">
        <div className="absolute top-[8px] left-[8px]">
          <Tooltip title="coming soon">
            <img
              src="/images/fi_info_wh.svg"
              alt="info"
              className="inline-block ml-[8px]"
            />
          </Tooltip>
        </div>
        <div className="flex flex-col items-center justify-center flex-shrink-0">
          <span className="text-[11px] font-[500]">Tier 1</span>
          <h3 className="font-[300] text-[16px] leading-[25px] tracking-[-1px]">
            {qualifying_loan_amounts !== null && qualifying_loan_amounts !== undefined &&
              qualifying_loan_amounts
                ?.slice(0, 1)
                .map((item, index) => (
                  <span className="font-[600]">
                    {item.bonus_type === 2 && "$ "}
                    {item?.bonus}
                    {item.bonus_type === 1 && " %"}
                  </span>
                ))}
          </h3>
          <span className="text-[10px] font-[400]">Bonus Amount</span>
        </div>
        {qualifying_loan_amounts !== undefined && qualifying_loan_amounts !== null && qualifying_loan_amounts.length > 1 && (
          <div className="flex-shrink-0 border-l border-white text-[12px] pl-[15px]">
            {qualifying_loan_amounts.slice(1).map((item, idx) => {
              return (
                <div className="mb-[10px] last:mb-[0]">
                  <div>
                    Tier {idx + 2}: {item.bonus_type === 2 && "$"}
                    {item?.bonus}
                    {item.bonus_type === 1 && "%"}
                  </div>
                  <div>
                    ${item?.minimum_loan_amount} to ${item?.maximum_loan_amount}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className="p-[17px_27px_3px_27px] flex-[1]">
        <h3 className="text-[#27272B] text-[14px] font-[700] mb-[14px] flex items-center justify-between">
          {name}{" "}
          {props.editOpt && props.pagePermissions?.update_permission == 1 && (
            <>
              <span
                className="cursor-pointer max-[450px]:absolute max-[450px]:top-[13px] max-[450px]:right-[14px]"
                onClick={handleClick}
              >
                <img
                  src="/images/menu_horz.svg"
                  className="max-[450px]:hidden"
                  alt="edit"
                />
                <img
                  src="/images/menu_horz_white.svg"
                  className="hidden max-[450px]:block"
                  alt="edit"
                />
              </span>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    minWidth: "170px",
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {props.pagePermissions?.update_permission == 1 && (
                  <MenuItem
                    onClick={() => handleClose("edit")}
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: '"Inter", sans-serif',
                    }}
                  >
                    <BorderColorOutlined
                      className="mr-[12px]"
                      fontSize={"small"}
                      htmlColor="#59758a"
                    />{" "}
                    Edit
                  </MenuItem>
                )}
                {props.pagePermissions?.delete_permission == 1 && (
                  <MenuItem
                    onClick={() => handleClose("del")}
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: '"Inter", sans-serif',
                    }}
                  >
                    <DeleteOutline
                      className="mr-[12px]"
                      fontSize={"small"}
                      htmlColor="#59758a"
                    />{" "}
                    Delete
                  </MenuItem>
                )}
              </Menu>
            </>
          )}
        </h3>
        <div className="flex flex-wrap justify-between gap-[15px_30px] mb-[14px]">
          <div>
            <label className="text-[#787486] text-[13px] block mb-[5px]">
              Bonus Program Valid Period
            </label>
            <p className="flex items-center mb-[0] text-[#0F0F0F] font-[500] text-[13px]">
              <img
                src="/images/fi_calendar.svg"
                alt="calendar"
                className="mr-[5px]"
              />
              {formatedStartDate} <span className="mx-[7px]">to</span>{" "}
              {formatedEndDate}
            </p>
          </div>
          <div className="min-w-[230px] max-w-full">
            <label className="text-[#787486] text-[13px] block mb-[5px]">
              Qualifying loan amount
            </label>
            {qualifying_loan_amounts !== null &&
              qualifying_loan_amounts
                ?.slice(0, 1)
                .map((item, idx) => (
                  <p className="text-[#0F0F0F] mb-[0] font-[500] text-[13px] mb-[2px]">
                    <span className="inline-block">
                      ${item?.minimum_loan_amount}{" "}
                    </span>
                    <span className="mx-[7px]">to</span>
                    <span className="inline-block">
                      {" "}
                      ${item?.maximum_loan_amount}
                    </span>
                  </p>
                ))}
          </div>
          <div>
            <label className="text-[#787486] text-[13px] block mb-[5px]">
              Qualifying period & Payout
            </label>
            <p className="text-[#0F0F0F] mb-[0] font-[500] text-[13px]">
              {bonDisPeriod} payout within {payout_days} days after end of
              qualifying period
            </p>
          </div>
        </div>
      </div>
      <Dialog
        open={delPopOpen}
        onClose={handleCloseDel}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          sx={{ textAlign: "center", fontFamily: '"Inter", sans-serif' }}
          id="responsive-dialog-title"
        >
          {"Are you sure want to delete?"}
        </DialogTitle>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            autoFocus
            sx={{ color: "red" }}
            onClick={() => handleCloseDel("del")}
          >
            Delete
          </Button>
          <Button onClick={handleCloseDel} autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
    // <div className="w-full mb-[15px] max-[450px]:flex-col max-w-full bg-white rounded-[8px] border border-[#E0E0E0] flex overflow-hidden relative">
    //   <div className="bg-[#0E085C] text-white flex flex-col items-center justify-center relative w-[140px] max-w-full flex-shrink-0 max-[450px]:w-full max-[450px]:py-[20px]">
    //     <div className="absolute top-[8px] left-[8px]">
    //             <Tooltip title="coming soon">
    //                 <img src="/images/fi_info_wh.svg" alt="info" className="inline-block ml-[8px]"/>
    //                 </Tooltip>
    //     </div>
    //     <h3 className="font-[800] text-[20px] leading-[25px] tracking-[-1px]">{bonus_type === 2 && <span className="font-[600]">$</span>} {bonus} {bonus_type === 1 && '%'}</h3>
    //     <span className="text-[10px] font-[400]">Bonus Amount</span>
    //   </div>
    //   <div className="p-[17px_27px_3px_27px] flex-[1]">
    //     <h3 className="text-[#27272B] text-[14px] font-[700] mb-[14px] flex items-center justify-between">{name}
    //     </h3>
    //     <div className="flex flex-wrap items-center justify-between gap-[15px_30px] mb-[14px]">
    //       <div>
    //         <label className="text-[#787486] text-[13px] block mb-[5px]">Bonus Program Valid Period</label>
    //         <p className="flex items-center mb-[0] text-[#0F0F0F] font-[500] text-[13px]">
    //           <img src="/images/fi_calendar.svg" alt="calendar" className="mr-[5px]" />
    //           {formatedStartDate}   <span className="mx-[7px]">to</span>  {formatedEndDate}
    //         </p>
    //       </div>
    //       <div>
    //         <label className="text-[#787486] text-[13px] block mb-[5px]">Qualifying loan amount</label>
    //         <p className="text-[#0F0F0F] mb-[0] font-[500] text-[13px]">${minimum_loan_amount}  <span className="mx-[7px]">to</span>  ${maximum_loan_amount}</p>
    //       </div>
    //       <div>
    //         <label className="text-[#787486] text-[13px] block mb-[5px]">Qualifying period & Payout</label>
    //         <p className="text-[#0F0F0F] mb-[0] font-[500] text-[13px]">{bonDisPeriod} payout within {payout_days} days after end of qualifying period</p>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default BonusCard;
